'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  user-select: none;\n  width: 33%;\n  display: flex;\n  justify-content: center;\n\n  .paginator {\n    display: inline-flex;\n    border: 1px solid ', ';\n    height: 24px;\n    border-radius: 2px;\n  }\n\n  .arrow-left {\n    justify-self: flex-start;\n  }\n\n  .arrow-right {\n    justify-self: flex-end;\n  }\n\n  .disabled-arrow {\n    color: ', ';\n    cursor: default;\n  }\n\n  .enabled-arrow {\n    cursor: pointer;\n  }\n'], ['\n  user-select: none;\n  width: 33%;\n  display: flex;\n  justify-content: center;\n\n  .paginator {\n    display: inline-flex;\n    border: 1px solid ', ';\n    height: 24px;\n    border-radius: 2px;\n  }\n\n  .arrow-left {\n    justify-self: flex-start;\n  }\n\n  .arrow-right {\n    justify-self: flex-end;\n  }\n\n  .disabled-arrow {\n    color: ', ';\n    cursor: default;\n  }\n\n  .enabled-arrow {\n    cursor: pointer;\n  }\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  padding-top: 4px;\n  padding-bottom: 6px;\n  padding-left: 5px;\n  padding-right: 5px;\n\n  width: ', ';\n  border-bottom: ', ';\n  color: ', ';\n  cursor: ', ';\n\n  :first-child {\n    margin-left: 8px;\n  }\n\n  :last-child {\n    margin-right: 8px;\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  padding-top: 4px;\n  padding-bottom: 6px;\n  padding-left: 5px;\n  padding-right: 5px;\n\n  width: ', ';\n  border-bottom: ', ';\n  color: ', ';\n  cursor: ', ';\n\n  :first-child {\n    margin-left: 8px;\n  }\n\n  :last-child {\n    margin-right: 8px;\n  }\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  width: 10px;\n  color: ', ';\n  padding: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 0 auto;\n  cursor: pointer;\n'], ['\n  width: 10px;\n  color: ', ';\n  padding: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 0 auto;\n  cursor: pointer;\n']),
  _templateObject4 = _taggedTemplateLiteral(['\n  width: auto;\n  display: flex;\n  justify-content: space-around;\n  flex: 1 0 auto;\n  border-left: 1px solid ', ';\n  border-right: 1px solid ', ';\n  font-size: 12px;\n'], ['\n  width: auto;\n  display: flex;\n  justify-content: space-around;\n  flex: 1 0 auto;\n  border-left: 1px solid ', ';\n  border-right: 1px solid ', ';\n  font-size: 12px;\n']),
  _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-self: flex-end;\n  width: 8px;\n  padding: 4px 5px;\n\n  svg {\n    height: 0.7em;\n    vertical-align: -1.125em;\n    color: ', ';\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  align-self: flex-end;\n  width: 8px;\n  padding: 4px 5px;\n\n  svg {\n    height: 0.7em;\n    vertical-align: -1.125em;\n    color: ', ';\n  }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var _XactlyColors = require('../../themes/XactlyColors');
var _XactlyColors2 = _interopRequireDefault(_XactlyColors);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var PaginatorWrapper = _styledComponents2['default'].span.withConfig({
  displayName: 'Paginator__PaginatorWrapper',
  componentId: 'f4hvo5-0'
})(_templateObject, _XactlyColors2['default'].xGreyDark, _XactlyColors2['default'].xGreyDark);
var PageItem = _styledComponents2['default'].span.withConfig({
  displayName: 'Paginator__PageItem',
  componentId: 'f4hvo5-1'
})(_templateObject2, function (props) {
  if (props.totalPagesCount >= 100) {
    return '12px';
  } else if (props.totalPagesCount >= 10) {
    return '10px';
  } else {
    return '8px';
  }
}, function (props) {
  return props.isSelected ? '2px solid ' + _XactlyColors2['default'].xSky : null;
}, function (props) {
  return props.isSelected ? _XactlyColors2['default'].xSky : props.theme.colorTextModerate;
}, function (props) {
  return props.isSelected ? 'default' : 'pointer';
});
PageItem.displayName = 'PageItem';
var Arrow = _styledComponents2['default'].div.withConfig({
  displayName: 'Paginator__Arrow',
  componentId: 'f4hvo5-2'
})(_templateObject3, function (_ref) {
  var colorTextModerate = _ref.theme.colorTextModerate;
  return colorTextModerate;
});
var PageNumberContainer = _styledComponents2['default'].div.withConfig({
  displayName: 'Paginator__PageNumberContainer',
  componentId: 'f4hvo5-3'
})(_templateObject4, _XactlyColors2['default'].xGreyDark, _XactlyColors2['default'].xGreyDark);
var EllipsisWrapper = _styledComponents2['default'].div.withConfig({
  displayName: 'Paginator__EllipsisWrapper',
  componentId: 'f4hvo5-4'
})(_templateObject5, function (_ref2) {
  var colorTextModerate = _ref2.theme.colorTextModerate;
  return colorTextModerate;
});
var EllipsisIcon = _react2['default'].createElement(EllipsisWrapper, null, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
  icon: _freeSolidSvgIcons.faEllipsisH
}));
var Paginator = function (_Component) {
  _inherits(Paginator, _Component);
  function Paginator() {
    _classCallCheck(this, Paginator);
    return _possibleConstructorReturn(this, (Paginator.__proto__ || Object.getPrototypeOf(Paginator)).apply(this, arguments));
  }
  _createClass(Paginator, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
          currentPage = _props.currentPage,
          itemsPerPage = _props.itemsPerPage,
          totalItems = _props.totalItems;
        var totalPages = Math.ceil(totalItems / itemsPerPage);
        var disabledRightArrow = currentPage === totalPages || totalItems === 0;
        var disabledLeftArrow = currentPage - 1 === 0 || totalItems === 0;
        var totalPagesArray = this.generatePageNumberArray(totalPages);
        return _react2['default'].createElement(PaginatorWrapper, null, _react2['default'].createElement('div', {
          className: 'paginator'
        }, this.renderArrow(disabledLeftArrow, 'left', _freeSolidSvgIcons.faChevronLeft), this.renderPageNumberContainer(totalPagesArray, currentPage, itemsPerPage), this.renderArrow(disabledRightArrow, 'right', _freeSolidSvgIcons.faChevronRight)));
      }
      return render;
    }()
  }, {
    key: 'renderArrow',
    value: function () {
      function renderArrow(isDisabled, type, icon) {
        var _this2 = this;
        return _react2['default'].createElement(Arrow, {
          onClick: isDisabled ? null : function () {
            return _this2.onArrowClick(type + 'Arrow');
          },
          className: 'arrow-' + type + ' ' + (isDisabled && 'disabled-arrow')
        }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: icon
        }));
      }
      return renderArrow;
    }()
  }, {
    key: 'renderPageNumberContainer',
    value: function () {
      function renderPageNumberContainer(totalPagesArray, currentPage) {
        var firstPage = totalPagesArray[0];
        var lastPage = totalPagesArray[totalPagesArray.length - 1];
        var totalPagesCount = totalPagesArray.length;
        if (totalPagesArray.length <= 5) {
          /*
            Don't show ellipsis at all
          */
          return _react2['default'].createElement(PageNumberContainer, null, this.renderPageNumbers(totalPagesArray, totalPagesCount));
        } else if (currentPage < 4) {
          /*
            Show ellipsis only on right side
            [pages] ... [last page]
            Criteria implied from previous statements:
              - Pages is > 5
          */
          var leftSidePages = totalPagesArray.slice(0, 5);
          return _react2['default'].createElement(PageNumberContainer, {
            withEllipsis: true
          }, this.renderPageNumbers(leftSidePages, totalPagesCount), EllipsisIcon, this.renderPageNumbers([lastPage], totalPagesCount));
        } else if (currentPage < totalPagesArray.length - 4) {
          /*
            Show Ellipsis on both sides.
            [first page] ... [pages] ... [last page]
            Criteria implied from previous statements:
              - Pages is > 5
              - Current page is >= 4
          */
          var centerPages = totalPagesArray.slice(currentPage - 2, currentPage + 1);
          return _react2['default'].createElement(PageNumberContainer, {
            withEllipsis: true
          }, this.renderPageNumbers([firstPage], totalPagesCount), EllipsisIcon, this.renderPageNumbers(centerPages, totalPagesCount), EllipsisIcon, this.renderPageNumbers([lastPage], totalPagesCount));
        } else {
          /*
            Show Ellipsis only on left side.
            Criteria implied from previous statements:
              - Pages is > 5
              - Current page is >= 4
              - Current page is >= total pages - 4
          */
          var rightSidePages = totalPagesArray.slice(totalPagesArray.length - 5);
          return _react2['default'].createElement(PageNumberContainer, {
            withEllipsis: true
          }, this.renderPageNumbers([firstPage], totalPagesCount), EllipsisIcon, this.renderPageNumbers(rightSidePages, totalPagesCount));
        }
      }
      return renderPageNumberContainer;
    }()
  }, {
    key: 'renderPageNumbers',
    value: function () {
      function renderPageNumbers(pageNumbers, totalPagesCount) {
        var _props2 = this.props,
          currentPage = _props2.currentPage,
          onPageClick = _props2.onPageClick;
        return pageNumbers.map(function (pageNumber) {
          var isCurrentPage = pageNumber === currentPage;
          return _react2['default'].createElement(PageItem, {
            key: pageNumber,
            totalPagesCount: totalPagesCount,
            isSelected: isCurrentPage,
            onClick: isCurrentPage ? null : function () {
              return onPageClick(pageNumber);
            }
          }, pageNumber);
        });
      }
      return renderPageNumbers;
    }()
  }, {
    key: 'generatePageNumberArray',
    value: function () {
      function generatePageNumberArray(pages) {
        return [].concat(_toConsumableArray(Array(pages).keys())).map(function (x) {
          return x + 1;
        });
      }
      return generatePageNumberArray;
    }()
  }, {
    key: 'onArrowClick',
    value: function () {
      function onArrowClick(clickValue) {
        var _props3 = this.props,
          currentPage = _props3.currentPage,
          onPageClick = _props3.onPageClick;
        var newPageNumber = clickValue === 'rightArrow' ? currentPage + 1 : currentPage - 1;
        onPageClick(newPageNumber);
      }
      return onArrowClick;
    }()
  }]);
  return Paginator;
}(_react.Component);
Paginator.propTypes = {
  /* This is a function that is passed in.  When it is called it will be passed the new page */
  onPageClick: _propTypes2['default'].func.isRequired,
  /* This is the length of the full array of data */
  totalItems: _propTypes2['default'].number,
  /* This prop determines how many rows of data are shown on each page */
  itemsPerPage: _propTypes2['default'].number.isRequired,
  /* this props is what determines which number is highlighted and what slice is shown */
  currentPage: _propTypes2['default'].number.isRequired
};
Paginator.defaultProps = {
  currentPage: 1
};
exports['default'] = Paginator;